import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import DocumentSubcategory from "../../models/document-subcategory";

interface DocumentSubcategoryDeleteModalProps {
  show: boolean;
  documentSubcategory?: DocumentSubcategory;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const DocumentSubcategoryDeleteModal: React.FC<
  DocumentSubcategoryDeleteModalProps
> = ({ show, documentSubcategory, onCancel, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  const message = documentSubcategory
    ? `Está seguro de que quiere eliminar la subcategoría de documento ${documentSubcategory.name}`
    : "";

  const onDeleteClick = async () => {
    if (documentSubcategory !== undefined) {
      setSubmitting(true);
      const typeStatus = await deleteItem<DocumentSubcategory>(
        `/document_subcategories/${documentSubcategory.id}/`,
        documentSubcategory
      );

      if (typeStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (typeStatus.detail !== undefined) {
          message = typeStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default DocumentSubcategoryDeleteModal;
